import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import { initGA } from './utils/analytics';
import { initPerformanceOptimizations } from './utils/performance';

// Initialize Google Analytics
initGA();

// Initialize Performance Optimizations
initPerformanceOptimizations();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);